import {AsyncState} from "../asyncState";
import {createSlice} from "@reduxjs/toolkit";
import {Category} from "./types";
import {fetchCategories} from "./thunks";
import {updateProductSortOrder} from "../products/thunks";

/**
 * categorySlice の型
 */
export type CategoryState = AsyncState<Category[]>;

/**
 * uses/{userId}/Categorys コレクションのデータ
 */
const categorySlice = createSlice({
  name: 'categories',
  initialState: {
    data: [],
    status: "idle",
    error: "",
  } as CategoryState,
  reducers: {

  },
  extraReducers: builder => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "succeeded";
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });

    builder
      .addCase(updateProductSortOrder.fulfilled, (state, action) => {
        state.data = action.payload.categories;
      });
  }
});

const categoryReducer = categorySlice.reducer;
export default categoryReducer;
